import { render, staticRenderFns } from "./UiShowTickets.vue?vue&type=template&id=00728bdb&lang=pug&"
import script from "./UiShowTickets.vue?vue&type=script&lang=js&"
export * from "./UiShowTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports